import React from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { appliedSearchSelector } from '@src/store/metricLens/base/selectors';
import { setAppliedSearch } from '@src/store/metricLens/base/actions';
// eslint-disable-next-line react/display-name
const Search = () => {
  const searchText = useSelector(appliedSearchSelector);
  const dispatch = useDispatch();

  const onInputChange = (e) => {
    const inputText = e.target.value;
    dispatch(setAppliedSearch(inputText));
  };

  return (
    <Input
      placeholder="Search values"
      value={searchText}
      onChange={onInputChange}
      prefix={<SearchOutlined />}
      allowClear
    />
  );
};

export default Search;
